"use strict";

import angular from "angular";

import { Accounting } from "../../../gateway/Accounting/Accounting";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

class RequestNandaIADialogCtrl {
    Accounting = new Accounting();
    user = new UserDataAdapter().user();
    constructor($mdDialog, locals, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.toast = toast;
    }

    $onInit() {}

    onRequestNandaIA() {
        this.Accounting.requestProductGrowth({
            accountingId: this.locals.accountingEntity.props._id,
            pckge: this.locals.pkge,
            licenses: 1,
            email: this.user.username,
            options: {
                addedValue: "0",
                period: ""
            }
        });
        const options = {
            message: `Solicitação da Nanda IA enviada com sucesso`,
            after: {
                then: (result) => {},
                catch: (error) => {}
            },
            extOptions: {
                hideDelay: 3000
            }
        };
        this.toast.snackbar(options);
        this.$mdDialog.hide();
    }
}

angular.module("nucont.shared").controller("RequestNandaIADialogCtrl", [
        "$mdDialog",
        "locals",
        "toast",
        RequestNandaIADialogCtrl
    ]);
